import { SessionStorageManager } from '@atlas/core';
import { POPUP_SIGN_UP_DELAY_STORAGE_KEYS } from 'common/constants';
import dayjs from 'dayjs';

export const setNextShowForPopupSignUpDelay = () => {
  const nextDayMs = dayjs().add(1, 'd').valueOf();
  SessionStorageManager.setItem(POPUP_SIGN_UP_DELAY_STORAGE_KEYS.NEXT_SHOW, nextDayMs);
};
